module.exports = __webpack_public_path__ + "img/computer_close.c6058de3.svg";